module.exports = __webpack_public_path__ + "static/media/lock.70e232a0.svg";